<template>
  <Toaster position="bottom-right" :timeout="4000" />

  <slot />
</template>

<script setup lang="ts">
import Toaster from '~/components/ui/toast/Toaster.vue'

useHead({
  titleTemplate: title => (title ? `${title} - VRIFY` : 'VRIFY'),
})
</script>

<style>
@import '@/assets/css/admin.css';
</style>
